export const getEpoch = (value: string | number): number =>
  typeof value === 'string' ? Number(value) : value;

interface SaleCommunication {
  startDate: number;
  endDate: number;
  dateExtended?: number;
  enabled?: boolean;
  [key: string]: any;
}

export const isSaleLive = (saleCommunication: SaleCommunication | undefined): boolean => {
  if (!saleCommunication) return false;
  const currentTime = Math.floor(Date.now() / 1000);
  const { startDate, endDate, dateExtended } = saleCommunication;

  const isDuringSale = currentTime > startDate && currentTime < endDate;
  const isExtendedSalePeriod = Boolean(
    dateExtended && dateExtended > endDate && currentTime >= endDate && currentTime < dateExtended
  );

  return isDuringSale || isExtendedSalePeriod;
};
